var _g, _g2, _g3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgopadBgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1007,
    height: 1000,
    viewBox: "0 0 1007 1000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11_286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_11_286",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.033 156.916C663.075 176.085 729.845 219.145 778.264 279.597C826.683 340.048 854.123 414.61 856.443 492.027C858.762 569.444 835.834 645.514 791.121 708.756C746.408 771.997 682.335 818.977 608.575 842.604L602.252 822.863C671.728 800.609 732.079 756.357 774.196 696.789C816.312 637.22 837.908 565.568 835.723 492.647C833.539 419.727 807.692 349.496 762.086 292.555C716.479 235.615 653.587 195.055 582.903 177L588.033 156.916Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M588.033 156.916C663.075 176.085 729.845 219.145 778.264 279.597C826.683 340.048 854.123 414.61 856.443 492.027C858.762 569.444 835.834 645.514 791.121 708.756C746.408 771.997 682.335 818.977 608.575 842.604L602.252 822.863C671.728 800.609 732.079 756.357 774.196 696.789C816.312 637.22 837.908 565.568 835.723 492.647C833.539 419.727 807.692 349.496 762.086 292.555C716.479 235.615 653.587 195.055 582.903 177L588.033 156.916Z",
    stroke: "url(#paint0_angular_11_286)",
    strokeWidth: 97.3132,
    mask: "url(#path-1-inside-1_11_286)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_11_286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_11_286",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.033 156.916C663.075 176.085 729.845 219.145 778.264 279.597C826.683 340.048 854.123 414.61 856.443 492.027C858.762 569.444 835.834 645.514 791.121 708.756C746.408 771.997 682.335 818.977 608.575 842.604L602.252 822.863C671.728 800.609 732.079 756.357 774.196 696.789C816.312 637.22 837.908 565.568 835.723 492.647C833.539 419.727 807.692 349.496 762.086 292.555C716.479 235.615 653.587 195.055 582.903 177L588.033 156.916Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M588.033 156.916C663.075 176.085 729.845 219.145 778.264 279.597C826.683 340.048 854.123 414.61 856.443 492.027C858.762 569.444 835.834 645.514 791.121 708.756C746.408 771.997 682.335 818.977 608.575 842.604L602.252 822.863C671.728 800.609 732.079 756.357 774.196 696.789C816.312 637.22 837.908 565.568 835.723 492.647C833.539 419.727 807.692 349.496 762.086 292.555C716.479 235.615 653.587 195.055 582.903 177L588.033 156.916Z",
    stroke: "url(#paint1_angular_11_286)",
    strokeWidth: 97.3132,
    mask: "url(#path-2-inside-2_11_286)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11_286)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 499.631,
    cy: 499.778,
    r: 356,
    transform: "rotate(142.123 499.631 499.778)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M158.468 458.354C169.719 368.351 216.262 286.505 287.859 230.819C359.455 175.134 450.241 150.171 540.243 161.422C630.245 172.673 712.092 219.216 767.777 290.813C823.463 362.41 848.426 453.195 837.175 543.197C825.924 633.199 779.38 715.046 707.784 770.731C636.187 826.417 545.402 851.38 455.399 840.129C365.397 828.878 283.551 782.335 227.865 710.738C172.18 639.141 147.217 548.356 158.468 458.354Z",
    stroke: "#C0C0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11_286",
    x: 551.903,
    y: 125.916,
    width: 335.7,
    height: 747.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5,
    result: "effect1_foregroundBlur_11_286"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11_286",
    x: 432.903,
    y: 6.91608,
    width: 573.7,
    height: 985.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_11_286"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11_286",
    x: 117.615,
    y: 117.762,
    width: 764.033,
    height: 764.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.116667 0 0 0 0 0.0543499 0 0 0 0 0.0476389 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_286"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_286",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_11_286",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(499.701 502.714) rotate(56.3296) scale(356.901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0511206,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636828,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78723,
    stopColor: "#D7544F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877924,
    stopColor: "#D7544F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_11_286",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(499.701 502.714) rotate(56.3296) scale(356.901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0511206,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636828,
    stopColor: "#D7544F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78723,
    stopColor: "#D7544F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877924,
    stopColor: "#D7544F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgopadBgImg);
export default __webpack_public_path__ + "static/media/algopad-bg-img.3f418beecf56e20b8e9945ba45a7bb67.svg";
export { ForwardRef as ReactComponent };